import {SettingsCallApiActionTypes} from "../action-types";
import {SettingsCallApiActions} from "../actions";
import produce from 'immer';
import {Settings} from "../../domain/settings/settings";


interface SettingsState {
    loading: boolean | null;
    settings: Settings | null,
    error: string | null,
}

const initialState: SettingsState = {
    loading: null,
    settings: null,
    error: null,
}

const reducer = produce((state: SettingsState = initialState, action: SettingsCallApiActions) => {
    switch (action.type) {
        case SettingsCallApiActionTypes.SETTINGS_CALL_API_REQUEST_SEND:
            state.loading = true;
            return state;
        case SettingsCallApiActionTypes.SETTINGS_CALL_API_SUCCESS:
            state.loading = false;
            state.error = null;
            state.settings = action.payload;
            return state;
        case SettingsCallApiActionTypes.SETTINGS_CALL_API_ERROR:
            state.loading = false;
            state.error = action.payload;
            return state;
        case SettingsCallApiActionTypes.SETTINGS_CALL_API_UPDATE_REQUEST:
            state.loading = true;
            return state;
        case SettingsCallApiActionTypes.SETTINGS_CALL_API_UPDATE_SUCCESS:
            state.loading = false;
            state.error = null;
            return state;
        case SettingsCallApiActionTypes.SETTINGS_CALL_API_UPDATE_ERROR:
            state.error = action.payload;
            return state;
        default:
            return state;
    }
})

export default reducer;
